export const IGNORE_Y_DIFF_IN_PX = 50
